function getCookies() {
  const cookiestring = /vsg-features=[^;]+/.exec(document.cookie);
  const jsonValue = decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, '') : '');
  return jsonValue ? JSON.parse(jsonValue) : null;
}

export default getCookies;
